export function search() {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.triger').forEach(function (triger) {
      triger.addEventListener('click', function () {
        var accordion = this.parentNode.previousElementSibling;
        if (accordion.classList.contains('open')) {
          // 閉じるときのアニメーション速度を適用
          accordion.style.transition = 'opacity 0.5s ease, max-height 0.5s ease';
          accordion.classList.remove('open');
          accordion.style.maxHeight = '0';
        } else {
          // 開くときのアニメーション速度を適用
          accordion.style.transition = 'opacity 0.5s ease, max-height 1s ease'; // ここで開く速度を調整
          accordion.classList.add('open');
          accordion.style.maxHeight = '100px';
        }
      });
    });

    document.querySelectorAll('.close').forEach(function (close) {
      close.addEventListener('click', function () {
        var accordion = this.parentNode;
        // 閉じるときのアニメーション速度を適用
        accordion.style.transition = 'opacity 0.5s ease, max-height 0.5s ease';
        accordion.classList.remove('open');
        accordion.style.maxHeight = '0';
      });
    });
  });

}
